import React from "react";
import PropTypes from "prop-types";
import { View, Text } from "@react-pdf/renderer";
import styles from "./variables.styles";

export default function Variables({ audienceVariables }) {
  return (
    <View style={styles.card}>
      <Text style={styles["card-title"]}>Selected Variables</Text>
      <VariableList list={audienceVariables} />
    </View>
  );
}

Variables.propTypes = {
  audienceVariables: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({})))
    .isRequired
};

function VariableList({ list }) {
  return (
    <View style={styles["preset-variable-list"]}>
      {list.map((groups, index) => (
        <VariableGroup
          key={groups.id}
          variables={groups}
          showAnd={index !== 0}
        />
      ))}
    </View>
  );
}

VariableList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired
};

function VariableGroup({ variables, showAnd }) {
  return (
    <View style={styles["group-container"]}>
      {showAnd && <Text style={styles.operand}>AND</Text>}
      <View style={styles.group}>
        {variables.map((variable, varIndex) => (
          <>
            <View
              style={styles["variable-item-container"]}
              key={`preset-variable-list-render-${variable.id}`}
            >
              <Text style={styles["variable-item"]}>{variable.name}</Text>
            </View>
            {varIndex !== variables.length - 1 && (
              <View style={styles["group-operand-container"]}>
                <Text style={styles["group-operand"]}>OR</Text>
              </View>
            )}
          </>
        ))}
      </View>
    </View>
  );
}

VariableGroup.propTypes = {
  variables: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    })
  ).isRequired,
  showAnd: PropTypes.bool.isRequired
};
